import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-help',
  templateUrl: './icon-help.component.html',
  styleUrls: ['./icon-help.component.scss']
})
export class IconHelpComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
